module.exports = __webpack_public_path__ + "img/village-open.75187225.png";